export function regexMarkFinder(searchTerm, fullText) {
  return fullText.indexOf(searchTerm);
}